import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import reportOutputReadAction from './reportOutputRead.action.json' with { type: 'json' }

const reportOutputReadDefinition = defineReadAutoAction(reportOutputReadAction, 'reportOutput')

export default reportOutputReadDefinition
